// VolcanoesAndRiftvalleys.js
import React, { useState } from 'react';
import { Container, Card } from 'react-bootstrap';
// Import your images here
import bannerImg from '../../../Assets/imagesssss/1/10008.jpg';
import vol1 from '../../../Assets/imagesssss/1/2.jpg';
import vol2 from '../../../Assets/imagesssss/1/2.jpg';
import vol3 from '../../../Assets/imagesssss/1/2.jpg';
import vol4 from '../../../Assets/imagesssss/1/2.jpg';
import vol5 from '../../../Assets/imagesssss/1/2.jpg';
import vol6 from '../../../Assets/imagesssss/1/2.jpg';
import rift1 from '../../../Assets/imagesssss/1/2.jpg';
import rift2 from '../../../Assets/imagesssss/1/2.jpg';
import rift3 from '../../../Assets/imagesssss/1/2.jpg';
import rift4 from '../../../Assets/imagesssss/1/2.jpg';
import rift5 from '../../../Assets/imagesssss/1/2.jpg';
import rift6 from '../../../Assets/imagesssss/1/2.jpg';
import styles from'./VolcanoesAndRiftvalleys.module.css';
const VolcanoesAndRiftvalleys = () => {
  const [scrollPosition1, setScrollPosition1] = useState(0);
  const [scrollPosition2, setScrollPosition2] = useState(0);

  const volcanoes = [
    {
      id: 1,
      title: "Erta Ale Volcano",
      description: "Step Into a Sea of White: Afar's Endless Salt Plains Await!",
      image: vol1
    },
    {
      id: 2,
      title: "Dallol Volcano",
      description: "Where Earth Meets the Sky in a Dazzling Salt Desert",
      image: vol2
    },
    {
      id: 3,
      title: "Ale Bagu",
      description: "Experience Afar's Salt Plains: A Landscape of Crystals and Contrast.",
      image: vol3
    },
    {
      id: 4,
      title: "Dubbre Volcano",
      description: "Walk the Ancient Trails of Afar’s Salt-Carved Wonders.",
      image: vol4
    },
    {
      id: 5,
      title: "Kurub Volcano",
      description: "Afar Salt Plains: Nature’s Gleaming Canvas Under the Sun.",
      image: vol5
    },
    {
      id: 6,
      title: "Dama Ale",
      description: "Discover the Pure, Raw Beauty of Afar’s Timeless Salt Plains.",
      image: vol6
    }
  ];

  const riftValleys = [
    {
      id: 7,
      title: "Danakil Depression",
      description: "Reflections of Wonder: Dive into Afar’s Magical Salt Lakes.",
      image: rift1
    },
    {
      id: 8,
      title: "Afar Triangle",
      description: "Afar’s Salt Lakes: Mirrored Worlds and Mesmerizing Colors.",
      image: rift2
    },
    {
      id: 9,
      title: "Lake Afdera",
      description: "Witness the Beauty of Salt and Sun at Afar’s Shimmering Lakes.",
      image: rift3
    },
    {
      id: 10,
      title: "Salt Plains",
      description: "Explore Afar’s Salt Lakes: Where Nature Paints with Minerals and Light",
      image: rift4
    },
    {
      id: 11,
      title: "Awash Valley",
      description: "Lake Assal and Afrera: Afar’s Dazzling Saltwater Gems.",
      image: rift5
    },
    {
      id: 12,
      title: "Yangudi Rassa",
      description: "Afar’s Lakes: Silent, Saline Waters Amidst a Fiery Landscape.",
      image: rift6
    }
  ];

  const handleScroll = (direction, row) => {
    const scrollAmount = 300;
    if (row === 1) {
      const maxScroll = volcanoes.length * 300;
      setScrollPosition1(prev => {
        const newPosition = direction === 'left' 
          ? prev - scrollAmount 
          : prev + scrollAmount;
        if (newPosition < 0) return 0;
        if (newPosition > maxScroll) return maxScroll;
        return newPosition;
      });
    } else {
      const maxScroll = riftValleys.length * 300;
      setScrollPosition2(prev => {
        const newPosition = direction === 'left' 
          ? prev - scrollAmount 
          : prev + scrollAmount;
        if (newPosition < 0) return 0;
        if (newPosition > maxScroll) return maxScroll;
        return newPosition;
      });
    }
  };

  return (
    <div className={styles.volcanoesPage}>
  <div className={styles.banner} style={{ backgroundImage: `url(${bannerImg})` }}>
    <h1>Salt Plains And Lakes</h1>
    <p>Uncover the Timeless Beauty of Afar’s Glowing Salt Plains and Mirrored Lakes</p>
  </div>

  <div className={styles.carouselSection}>
    <h2>Salt Plains</h2>
    <Container className={styles.descriptionContainer}>
      <Card className={styles.descriptionCard}>
        <Card.Body>
          <Card.Text>
            The Afar region's salt plains and lakes form one of the most mesmerizing and extreme landscapes on Earth. Lake Assal and Lake Afrera are among the region’s well-known saline lakes, surrounded by vast salt flats that create a glistening, otherworldly panorama. These salt plains, especially the Danakil Depression, are often covered with pure white salt crusts stretching for miles, contrasting with the surreal mineral colors and geothermal activity in the area.
          </Card.Text>
        </Card.Body>
      </Card>
    </Container>

    <div className={styles.carouselContainer}>
      <button 
        className={`${styles.scrollButton} ${styles.left}`} 
        onClick={() => handleScroll('left', 1)}
      >
        &#8249;
      </button>
      <div className={styles.cardsContainer}>
        <div 
          className={styles.cardsTrack}
          style={{ transform: `translateX(-${scrollPosition1}px)` }}
        >
          {volcanoes.map(item => (
            <div className={styles.card} key={item.id}>
              <div className={styles.cardImage}>
                <img src={item.image} alt={item.title} />
              </div>
              <div className={styles.cardContent}>
                <h3>{item.title}</h3>
                <p>{item.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
      <button 
        className={`${styles.scrollButton} ${styles.right}`} 
        onClick={() => handleScroll('right', 1)}
      >
        &#8250;
      </button>
    </div>

    <h2>Lakes</h2>
    <Container className={styles.descriptionContainer}>
      <Card className={styles.descriptionCard}>
        <Card.Body>
          <Card.Text>
            For centuries, Afar's salt plains have been a hub for traditional salt mining. Local Afar people continue to extract salt slabs by hand, a practice passed down through generations and transported by camel caravans across the desert. This region’s unique combination of harsh beauty, ancient trade routes, and vibrant mineral landscapes makes it a fascinating destination for explorers and photographers alike.
          </Card.Text>
        </Card.Body>
      </Card>
    </Container>

    <div className={styles.carouselContainer}>
      <button 
        className={`${styles.scrollButton} ${styles.left}`} 
        onClick={() => handleScroll('left', 2)}
      >
        &#8249;
      </button>
      <div className={styles.cardsContainer}>
        <div 
          className={styles.cardsTrack}
          style={{ transform: `translateX(-${scrollPosition2}px)` }}
        >
          {riftValleys.map(item => (
            <div className={styles.card} key={item.id}>
              <div className={styles.cardImage}>
                <img src={item.image} alt={item.title} />
              </div>
              <div className={styles.cardContent}>
                <h3>{item.title}</h3>
                <p>{item.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
      <button 
        className={`${styles.scrollButton} ${styles.right}`} 
        onClick={() => handleScroll('right', 2)}
      >
        &#8250;
      </button>
    </div>
  </div>
</div>
  );
};

export default VolcanoesAndRiftvalleys;